/**
 * Canonical site-wide constants (nav, footer, contact endpoints).
 *
 * Defined once here rather than duplicated per page — a nav change is one
 * edit instead of one per page.
 */

export const SITE = {
  name: 'LearnAI',
  origin: 'https://example.com',
  phone: '(555) 123-4567',
  phoneHref: 'tel:+15551234567',
  email: 'hello@learnpsl.ai',
  googleAnalyticsId: undefined as string | undefined,
} as const;

export interface NavItem {
  readonly label: string;
  readonly href: string;
}

export const NAV_ITEMS: readonly NavItem[] = [
  { label: 'Home', href: '/' },
  { label: 'How It Works', href: '/how-it-works' },
  { label: 'About Us', href: '/about' },
  { label: 'Pricing', href: '/pricing' },
  { label: 'Contact Us', href: '/contact' },
] as const;

export const FOOTER_LINKS: readonly NavItem[] = [
  { label: 'Home', href: '/' },
  { label: 'How It Works', href: '/how-it-works' },
  { label: 'About Us', href: '/about' },
  { label: 'Pricing', href: '/pricing' },
  { label: 'Contact Us', href: '/contact' },
] as const;

/**
 * Form endpoint. Submissions post to the standalone Cloudflare Worker
 * (worker/index.ts, configured via wrangler.toml) which validates Turnstile
 * and the honeypot before forwarding to CONTACT_WEBHOOK_URL.
 */
export const WEBHOOKS = {
  contact: 'https://learnai-web-contact-proxy.bndl.workers.dev',
} as const;

/** Cloudflare Turnstile configuration. */
export const TURNSTILE = {
  siteKey: '0x4AAAAAAE640DwjN0r0GE3h',
} as const;
